import React, { useState, useEffect, useCallback, useMemo } from "react";
import SSOService, { serviceUrl } from "./SSOService";
import { redirectPage } from "./Utils";

const resellersWithMaxWidth = new Set([
  "healthnexus.io",
  "purplelab.com",
  "rr.purplelab.com",
  "www.healthnexus.io"
]);

export const useLogoImage = () => {
  const domain = getDomainFromSearch();
  const reseller = getReseller(domain) || domain;
  const defaultLogo = useMemo(() => `${process.env.PUBLIC_URL}/logo.png`, []);

  const [logoSrc, setLogoSrc] = useState(
    domain
      ? `${process.env.PUBLIC_URL}/resellers/${reseller}/img/logo.png`
      : defaultLogo
  );

  const handleError = useCallback(() => {
    setLogoSrc(defaultLogo);
  }, [defaultLogo]);

  const logoMaxWidth = resellersWithMaxWidth.has(reseller);

  return { logoSrc, handleError, logoMaxWidth};
};

export const LogoImage = () => {
  const { logoSrc, handleError, logoMaxWidth } = useLogoImage();

  return (
    <img
      className={`login-logo ${logoMaxWidth ? 'max-width-logo' : ''}`}
      src={logoSrc}
      onError={handleError}
      alt="ssologo"
    />
  );
};

function getReseller(domain) {
  const regexDomain =
    /^(provider-groups-|concept-groups-)?(\w+)(\.healthnexus\.io|-portal\.purplelab\.com|\.agilereportretriever\.com)$/;
  const resellerDomain = regexDomain.exec(domain);
  if (resellerDomain == null || resellerDomain.length < 3 || resellerDomain[2] == null) {
    return "";
  }
  return resellerDomain[2];
}

export function getQueryParams() {
  const domainSearch = getRawDomainFromSearch();
  if (domainSearch && domainSearch !== "") {
    return `?domain=${domainSearch}`;
  }
  const domain = getRawDomain();
  if (domain && domain !== "") {
    return `?domain=${domain}`;
  }
  return "";
}
export function setup(id, domain, rawDomain) {
  window.localStorage.setItem("PSI", id);
  window.localStorage.setItem("PDOMAIN", domain);
  window.localStorage.setItem("RAWPDOMAIN", rawDomain);
}

export function handleSessionValidation(addToast) {
  const id = getPSI();
  const domain = getRawDomain();
  const rawDomain = getRawDomainFromSearch();
  const service = new SSOService();
  const isError = !id || !domain;
  const errorMessage = "Session timed out. Please reenter credentials";
  return new Promise((resolve, reject) => {
    if (rawDomain && rawDomain !== "" && isError) {
      addToast(errorMessage, "error");
      redirectPage(
        `${serviceUrl}/checklogin?returnUrl=${getReturnUrl(rawDomain)}`
      );
      reject(errorMessage);
      return;
    } else if (isError) {
      addToast(errorMessage, "error");
      redirectPage(`${serviceUrl}/checklogin`);
      reject(errorMessage);
      return;
    }
    return service
      .checkSession(id, domain)
      .then(() => {
        resolve();
      })
      .catch((err) => {
        addToast(errorMessage, "error");
        if (err.refreshSession === true) {
          redirectPage(`${serviceUrl}/checklogin?returnUrl=${err.returnUrl}`);
          reject(errorMessage);
          return;
        }
        redirectPage(`${serviceUrl}/checklogin`);
        reject(errorMessage);
      });
  });
}

function getReturnUrl(domain) {
  if (domain === "localhost") {
    return "http://localhost:8080";
  }
  return `https://${domain}`;
}

export function getPSI() {
  return window.localStorage.getItem("PSI");
}
export function getDomain() {
  return window.localStorage.getItem("PDOMAIN");
}

export function getRawDomain() {
  return window.localStorage.getItem("RAWPDOMAIN");
}

export function getDomainFromSearch() {
  const search = window.location.search;

  const domain = new URLSearchParams(search).get("domain");
  if (domain && domain.split("dev-").length > 1) {
    return domain.split("dev-")[1];
  }
  if (domain && domain.split("dev.").length > 1) {
    return domain.split("dev.")[1];
  }
  if (domain && domain.split("dev").length > 1) {
    return domain.split("dev")[1];
  }
  return domain || "";
}
export function getRawDomainFromSearch() {
  const search = window.location.search;
  const domain = new URLSearchParams(search).get("domain");
  return domain || "";
}

export function getPageToRedirect() {
  const search = window.location.search;
  const page = new URLSearchParams(search).get("pageToRedirect");
  return page || null;
}

const Theme = ({ children }) => {
  const { logoSrc, handleError } = useLogoImage();

  useEffect(() => {
    if (window.location.hash && window.location.hash.length > 0) {
      window.history.replaceState(null, null, " ");
    }
  }, []);
  return (
  <div className="App">
    {children}
    <img
      className="background-logo"
      src={logoSrc}
      aria-hidden="true"
      alt=""
      onError={handleError}
    />
  </div>
  );
};

export default Theme;
